import { makeStyles } from '@material-ui/core';
import styles from './FormStyles.styles';

const useStyles = makeStyles(styles);

export default function FormStyles() {
  useStyles();
  return null;
}
